import { Component, OnInit, ViewChild } from '@angular/core';
import { MCPlanningMaterialService } from '../../Services/MCPlanningMaterial/mcplanningmaterial.service'
import { FinalRequirementDetails, RequirementDetailsZMH, RequirementDetails } from 'src/app/Models/MCPlanningMaterial/mcplanningmaterial';
import { MatSnackBarComponent } from '../mat-snack-bar/mat-snack-bar.component'
import { DropDownResponse, MultiSelectCancellation, Requesters } from 'src/app/Models/Dashboard/DashboardFilters';
import { Router } from '@angular/router';
import { element } from '@angular/core/src/render3/instructions';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ToastrModule, ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-jobnumber-cancellation',
  templateUrl: './jobnumber-cancellation.component.html',
  styleUrls: ['./jobnumber-cancellation.component.css']

})
export class JobnumberCancellationComponent implements OnInit {
  @ViewChild('jobnumber') jobnumber;
  @ViewChild('brand') brand;
  @ViewChild('crop') crop;
  @ViewChild('jobtype') jobtype;
  @ViewChild('language') language;
  @ViewChild('rmh') rmh;
  @ViewChild('status') status;
  @ViewChild('requester') requester;
  @ViewChild('year') year;
  // @ViewChild('ma') ma;
  public jobNumberSettings = {};
  public brandSettings = {};
  public cropSettings = {};
  public jobTypeSettings = {};
  public languageSettings = {};
  public rmhSettings = {};
  yearSettings: IDropdownSettings  = {};
  public statusSettings = {};
  public requesterSettings = {};
  requirementId: string = '';
  public JobNumbers: any = [];
  public Remarks: any;
  multiSelectCancellation: MultiSelectCancellation[] = [];
  selectCheck: boolean = false;
  IsDisabled: boolean;
  loader: string = 'none';
  userID: string;
  roleID: string;
  selectedJobNumber: any = '';
  selectedRMHName: any = '';
  selectedJobType: any = '';
  selectedBrand: any = '';
  selectedCrop: any = '';
  selectedLanguage: any = '';
  selectedStatus: any = '';
  selectedRequested: any = '';
  selectedYear: any = '';
  displayPanel: string = 'none';
  displayMultiPanel: string = 'none';
  RemarksText: any;
  CancelledQty: any;
  fadeBackground: string;
  JobnumberId: any;
  ApprovedQty: any;
  remainingQty: any;
  cancellationType: any = '0';
  requirementdetails: RequirementDetails[] = [];
  //Added for Cancellation option (partial,full)
  cancelTrack: any = 0;
  mainRemainingQty: any;
  submitDisable: boolean = false;
  cancelTrackPartial: boolean = false;
  cancelTrackComplete: boolean = false;
  //End Add
  public ddlResponse: DropDownResponse = new DropDownResponse();
  constructor(private mcPlanningMaterialService: MCPlanningMaterialService, private router: Router, private snackBar: MatSnackBarComponent,private toastr: ToastrService) {
    this.roleID = localStorage.getItem('mcmt_roleID');
    this.userID = localStorage.getItem('mcmt_userId');
  }

  ngOnInit() {
    if (sessionStorage.tabID == undefined) {
      this.router.navigate(['/MCMaterial/Login']);
    }
    this.displayPanel = 'none';
    this.fadeBackground = 'none';
    this.displayMultiPanel = 'none';
    this.getFiltersOnPageLoad();
    this.jobNumberSetting();
    this.brandSetting();
    this.cropSetting();
    this.languageSetting();
    this.statusSetting();
    this.requesterSetting();
    this.jobTypeSetting();
    this.rmhSetting();
    this.YearSettings();    
  }
  getFiltersOnPageLoad() {
    this.loader = 'block';
    this.mcPlanningMaterialService.getRequirementDetailsForJobCancellation()
      .subscribe((resData: any) => {
        if (resData.status == true) {
          //this.dashboardFilters = resData.data as DashboardFilters;
          this.ddlResponse = resData.data;
          this.ddlResponse.year = resData.data.requirementYear;
          class YearItemList{
            id: string;
            text: string;
        }
          let requiredItem: YearItemList[] = [];
          var obj = {
            id : this.ddlResponse.year[0].currentrequirementYear,
            text: this.ddlResponse.year[0].currentrequirementYear
          }
          this.selectedYear = this.ddlResponse.year[0].currentrequirementYear;
          requiredItem.push(obj)
          this.year.selectedItems = requiredItem;
          let tempArray : Requesters[] = [];
          var temp;
          temp = {
            text : "Request Raised by MC"
          };
          tempArray.push(temp);
          temp = {
            text : "Request Raised by MA"
          };
          tempArray.push(temp);
          temp = {
            text : "Cancel Job Number"
          };
          tempArray.push(temp);
          this.ddlResponse.requester = tempArray;
          //this.ddlResponse.brands=resData.data;
          this.GetRequirementDetails();
          this.loader = 'none';
        }
        else {
          this.toastr.error(resData.msg);
          this.loader = 'none';
        }
      }
      );
  }
  GetRequirementDetails() {
    this.selectedRMHName = "";
    this.selectedCrop = "";
    this.selectedBrand = "";
    this.selectedJobType = "";
    this.selectedLanguage = "";
    this.selectedStatus = "";
    this.selectedJobNumber = "";
    this.selectedRequested = "";
    this.mcPlanningMaterialService.GetRequirementDetailForJobCancellation(this.selectedRMHName, this.selectedJobType, this.selectedBrand, this.selectedCrop, this.selectedLanguage, this.selectedStatus, this.selectedJobNumber, this.selectedRequested, this.selectedYear)
      .subscribe((responseData: any) => {
        if (responseData.status == true) {
          this.requirementdetails = responseData.data;
          this.loader = 'none';
          this.fadeBackground = 'none';
        }
        else {
          this.requirementdetails = responseData.data;
          this.toastr.error('No records Available');
          this.loader = 'none';
          this.fadeBackground = 'none';
        }
      })

  }
  filter() {
    let selectedJobnumber = '';
    let selectedRMH = '';
    let selectedBrand = '';
    let selectedCrop = '';
    let selectedJobtype = '';
    let selectedLanguage = '';
    let selectedStatus = '';
    let selectedRequested = '';
    let selectedYear = '';
    selectedJobnumber = Array.prototype.map.call(this.jobnumber.selectedItems, function (item) { return item.id; }).join(",");
    selectedRMH = Array.prototype.map.call(this.rmh.selectedItems, function (item) { return item.id; }).join(",");
    selectedBrand = Array.prototype.map.call(this.brand.selectedItems, function (item) { return item.id; }).join(",");
    selectedCrop = Array.prototype.map.call(this.crop.selectedItems, function (item) { return item.id; }).join(",");
    selectedJobtype = Array.prototype.map.call(this.jobtype.selectedItems, function (item) { return item.id; }).join(",");
    selectedStatus = Array.prototype.map.call(this.status.selectedItems, function (item) { return item.id; }).join(",");
    selectedLanguage = Array.prototype.map.call(this.language.selectedItems, function (item) { return item.id; }).join(",");
    selectedRequested = Array.prototype.map.call(this.requester.selectedItems, function (item) { return item.id; }).join(",");
    selectedYear = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");
    this.mcPlanningMaterialService.GetRequirementDetailForJobCancellation(selectedRMH, selectedJobtype, selectedBrand, selectedCrop, selectedLanguage, selectedStatus, selectedJobnumber,selectedRequested,selectedYear)
      .subscribe((responseData: any) => {
        if (responseData.status == true) {
          this.requirementdetails = responseData.data;
          this.loader = 'none';
          this.fadeBackground = 'none';
        }
        else {
          this.requirementdetails = responseData.data;
          this.toastr.error('No records Available');
          this.loader = 'none';
          this.fadeBackground = 'none';
        }
      })

  }
  checkSelected(index: number, jobnumber: string) {
    if (!this.requirementdetails[index]["isActive"] && this.requirementdetails[index]["isDisable"] == false) {
      //this.JobNumbers.splice(index-1,1);
      let i;
      i = this.JobNumbers.findIndex(item => item === jobnumber);
      this.JobNumbers.splice(i, 1);
    }
    else
      this.JobNumbers.push(this.requirementdetails[index]["jobNumber"]);
  }
  // check(index: any) {
  //   if(this.requirementdetails[index]["isActive"])
  //   {
  //     return 'true'
  //   }
  //   else{
  //     'false'
  //   }
  // }
  closePopup() {
    this.displayPanel = 'none';
    this.fadeBackground = 'none';
    this.displayMultiPanel = 'none';
    this.RemarksText = "";
    this.cancelTrack = 0;
  }
  displayPopup(jobnumber, approvedqty, requestedCancelledQty) {
    this.JobnumberId = jobnumber;
    this.ApprovedQty = approvedqty;
    this.remainingQty = approvedqty.replaceAll(',', '');
    this.mainRemainingQty = approvedqty.replaceAll(',', '');
    this.CancelledQty = requestedCancelledQty.replaceAll(',', '');
    this.displayPanel = 'block';
    this.fadeBackground = 'block';
    this.cancellationType = '0';
    this.cancelTrack == 0;
    if (requestedCancelledQty.replaceAll(',', '') > 0) {
      if (requestedCancelledQty.replaceAll(',', '') == approvedqty.replaceAll(',', '')) {
        this.cancelTrack = 1;
        var element = document.getElementById("cancelTrackRadioComplete");
        element.classList.add("mat-radio-checked");
        var element = document.getElementById("cancelTrackRadioPartial");
        element.classList.remove("mat-radio-checked");
        this.mainRemainingQty = this.remainingQty.replaceAll(',', '') - requestedCancelledQty.replaceAll(',', '');
      }
      else {
        this.cancelTrack = 2;
        var element = document.getElementById("cancelTrackRadioPartial");
        element.classList.add("mat-radio-checked");
        var element = document.getElementById("cancelTrackRadioComplete");
        element.classList.remove("mat-radio-checked");
        this.mainRemainingQty = this.remainingQty.replaceAll(',', '') - requestedCancelledQty.replaceAll(',', '');
      }
    }
  }

  CalculateRemainingQty(event: any) {
    this.mainRemainingQty = this.remainingQty;
    this.mainRemainingQty = this.remainingQty - event.target.value;
  }

  CancelTrackRadio(index: any) {
    if(index == 1){
      var element = document.getElementById("cancelTrackRadioComplete");
      element.classList.add("mat-radio-checked");
      var element = document.getElementById("cancelTrackRadioPartial");
      element.classList.remove("mat-radio-checked");
    }
    else{
      var element = document.getElementById("cancelTrackRadioPartial");
      element.classList.add("mat-radio-checked");
      var element = document.getElementById("cancelTrackRadioComplete");
      element.classList.remove("mat-radio-checked");
    }
  }

  ApproveRequirement(jobnumber) {
    this.loader = 'block';
    this.submitDisable = true;
    // if(this.JobNumbers.length==0)
    // {
    //   this.toastr.error('Please Select Jobnumber', 'Close', 'red-snackbar');
    //   this.RemarksText="";
    //   return false;
    // }
    if (this.cancelTrack == 0) {
      this.toastr.error('Please Select Cancellation Type.');
      return false;
    }
    if (this.cancelTrack == 1) {
      this.CancelledQty = this.ApprovedQty.replaceAll(',', '');
    }
    if (this.RemarksText == null) {
      this.RemarksText = "";
    }
    if (this.roleID == '51') {
      if (this.CancelledQty == null || this.CancelledQty == 0) {
        this.toastr.error('Please Enter Quantity to Cancel.');
        return false;
      }
    }
    if (this.roleID != '51') {
      if (this.CancelledQty == null || this.CancelledQty == 0) {
        this.CancelledQty = this.ApprovedQty.replaceAll(',', '')
      }
    }

    this.mcPlanningMaterialService.CancelJobnumbers(jobnumber, this.RemarksText, this.CancelledQty, this.ApprovedQty.replaceAll(',', ''))
      .subscribe((responseData: any) => {
        if (responseData.status) {
          this.toastr.success(responseData.message);
          this.submitDisable = false;
          this.filter();
          this.RemarksText = "";
          this.CancelledQty = "";
          this.ApprovedQty = "";
          this.loader = 'none';
          this.selectCheck = false;
          this.displayPanel = 'none';
          this.fadeBackground = 'none';
          this.JobNumbers = [];
          this.cancelTrack = 0;
        }
        else {
          this.toastr.error('Some error Occured,Could not update status');
          this.submitDisable = false;
          this.loader = 'none';
          this.displayPanel = 'none';
          this.RemarksText = "";
          this.CancelledQty = "";
          this.ApprovedQty = "";
          this.JobNumbers = [];
          this.fadeBackground = 'none';
          this.filter();
        }
      })
  }
  SelectAll() {
    this.JobNumbers = [];
    if (this.selectCheck == true) {
      this.requirementdetails.forEach(element => {
        if (element.status != "JobNumber Cancelled") {
          this.JobNumbers.push(element.jobNumber);
          element.isActive = true;
        }
      })
    }
    else {
      this.requirementdetails.forEach(element => {
        element.isActive = false;
      })
    }
  }
  // onJobNumberSelect(item: any) {
  //       this.getJobnumberWiseData(this.jobnumber.selectedItems);

  // }
  // onJobNumberSelectAll(item: any) {

  //   this.getJobnumberWiseData(this.jobnumber.selectedItems);

  // }
  // onJobNumberDeSelect(item: any) {
  //   this.getJobnumberWiseData(this.jobnumber.selectedItems);
  //   if (this.jobnumber.selectedItems.length == 0) {
  //     this.jobnumber.selectedItems = [];
  //     this.brand.selectedItems = [];
  //     this.crop.selectedItems = [];
  //     this.jobtype.selectedItems = [];
  //     this.language.selectedItems = [];
  //     if (this.roleID != '42') {
  //       this.rmh.selectedItems = [];
  //     }
  //     if (this.roleID != '42' && this.roleID != '48') {
  //       this.ma.selectedItems = [];
  //     }
  //     this.requirementType.selectedItems = [];
  //     this.status.selectedItems = [];
  //   }
  // }
  onJobNumberDeSelectAll(item: any) {

    this.jobnumber.selectedItems = [];
    // this.brand.selectedItems = [];
    // this.crop.selectedItems = [];
    // this.jobtype.selectedItems = [];
    // this.language.selectedItems = [];
    // this.rmh.selectedItems = [];
    // this.status.selectedItems = [];
  }

  YearSettings(){
    this.yearSettings = {
      singleSelection: true,
      idField: 'year',
      textField: 'year',
      enableCheckAll: false,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: false,
      limitSelection: -1,
      clearSearchFilter: false,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Year Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }

  onRMHDeSelect(item: any) {

    this.rmh.selectedItems = [];
  }
  onRMHDeSelectAll(item: any) {

    this.rmh.selectedItems = [];
  }
  // onRMHSelect(item: any) {

  //   this.getRMHWiseData(this.rmh.selectedItems);

  // }
  // onRMHSelectAll(item: any) {
  //   this.getRMHWiseData(this.rmh.selectedItems);

  // }


  // onbrandSelect(item: any) {
  //   this.getbrandWiseData(this.brand.selectedItems);
  // }
  // onbrandSelectAll(item: any) {
  //   this.getbrandWiseData(this.brand.selectedItems);
  // }
  // onbrandDeSelect(item: any) {
  //   if (this.brand.selectedItems.length < 1) {
  //     this.brand.selectedItems = [];
  //     this.crop.selectedItems = [];
  //     this.jobtype.selectedItems = [];
  //     this.language.selectedItems = [];
  //   }
  //   else
  //     this.getbrandWiseData(this.brand.selectedItems);
  // }
  // onbrandDeSelectAll(item: any) {
  //   this.brand.selectedItems = [];
  //   this.crop.selectedItems = [];
  //   this.jobtype.selectedItems = [];
  //   this.language.selectedItems = [];
  // }

  jobNumberSetting() {
    this.jobNumberSettings = {
      singleSelection: false,
      idField: 'jobNumber',
      textField: 'jobNumber',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Job Number Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  brandSetting() {
    this.brandSettings = {
      singleSelection: false,
      idField: 'brandID',
      textField: 'brandName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Brand Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }

  cropSetting() {
    this.cropSettings = {
      singleSelection: false,
      idField: 'cropID',
      textField: 'cropName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Crop Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  jobTypeSetting() {
    this.jobTypeSettings = {
      singleSelection: false,
      idField: 'jobTypeID',
      textField: 'jobTypeName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No JobType Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  languageSetting() {
    this.languageSettings = {
      singleSelection: false,
      idField: 'languageID',
      textField: 'languageName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Language Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  rmhSetting() {
    this.rmhSettings = {
      singleSelection: false,
      idField: 'rMHCode',
      textField: 'rMHName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No RMH Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }

  statusSetting() {
    this.statusSettings = {
      singleSelection: false,
      idField: 'requirementStatusID',
      textField: 'requirementStatusName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Status Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  
  requesterSetting() {
    this.requesterSettings = {
      singleSelection: false,
      idField: 'text',
      textField: 'text',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Status Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }

  displayAllPopup(){
    let tempArray: MultiSelectCancellation[] = [];
    this.requirementdetails.forEach(element =>{
      if(element.isActive == true && element.isDisable != true){
        var obj = {
          JobNumber : element.jobNumber,
          Remarks: '',
          CancelledQty: element.finalQuantity.replaceAll(',', ''),
          ApprovedQty: element.finalQuantity.replaceAll(',', '')
        }
        tempArray.push(obj);
      }
    })
    this.multiSelectCancellation = tempArray;
    this.displayMultiPanel = 'block';
    this.fadeBackground = 'block';
  }

  CancelAllJobNumber(){
    this.mcPlanningMaterialService.CancelAllJobnumbers(this.multiSelectCancellation)
      .subscribe((responseData: any) => {
        if (responseData.status) {
          this.toastr.success(responseData.message);
          this.submitDisable = false;
          this.GetRequirementDetails();
          this.RemarksText = "";
          this.CancelledQty = "";
          this.ApprovedQty = "";
          this.loader = 'none';
          this.selectCheck = false;
          this.displayPanel = 'none';
          this.fadeBackground = 'none';
          this.displayMultiPanel = 'none';
          this.JobNumbers = [];
          this.cancelTrack = 0;
        }
        else {
          this.toastr.error('Some error Occured,Could not update status');
          this.submitDisable = false;
          this.loader = 'none';
          this.displayPanel = 'none';
          this.displayMultiPanel = 'none';
          this.RemarksText = "";
          this.CancelledQty = "";
          this.ApprovedQty = "";
          this.JobNumbers = [];
          this.fadeBackground = 'none';
          this.GetRequirementDetails();
        }
      })
  }

  ConvertToCurrency(value:any)
  {
    var parts = value.toString().replace(',','').split(".");
    if(parts[0].length > 3){
      parts[0] = parts[0].slice(0,parts[0].length-3).replace(/\B(?=(\d{2})+(?!\d))/g, ",") +','+ parts[0].slice(parts[0].length-3,parts[0].length);
    }
    return parts.join(".");
  }
}
